import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

import { DemandActivity } from "../../../api/services";

export const useDemandActivity = (activity: DemandActivity) => {
  const { category, subcategory, id } = activity;
  const { url } = useRouteMatch();

  return useMemo(
    () => ({
      title: `${category} / ${subcategory}`,
      link: `${url}/wrapupnotes/${id}`,
    }),
    [category, id, subcategory, url],
  );
};
